
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.5 26.24V20.9L30 10.28 1.5 21v5.34zM57.51 51.15v7.29l-55 .12v-7.29zM52.57 50.73l-.06-23.59M7.51 27.24l.06 23.59M18.77 27.22l.05 23.12M30.02 27.19l.05 23.12M41.27 27.17l.05 23.11M29.95 1.52h7.94v5.34h-7.94zM29.96 4.93l.01 5.35","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    